<template>
  <base-content>
    <template v-if="loaded">
      <template slot="top">
        <hero-header :heading="`${state} Net Asset Statement`">
          <base-button exact icon-left="arrow-left" :to="{ name: 'asset-statements' }">
            Asset Statements
          </base-button>
        </hero-header>
      </template>
      <app-reviews v-if="reviewing" class="mb-4" service="assetStatements" />
      <form @submit.prevent="submit">
        <asset-calculator v-model="payload" :readonly="readonly" />
        <base-field>
          <base-textarea
            v-model="payload.other_information"
            disable-smart-placeholder
            placeholder="Please add notes here of any relevant information or details of unusual values or other assets/liabilities included."
            :readonly="readonly" />
        </base-field>
        <template v-if="$auth.borrower()">
          <hr>
          <h5>
            Declaration
          </h5>
          <p class="mb-0">
            Please confirm that the information provide is a complete, true and accurate record of my financial position.
            You acknowledge that we will rely on the information provided during any credit assessment.
          </p>
        </template>
        <template
          v-if="$auth.borrower() && action === 'editing'"
          slot="footer">
          <div class="text-right">
            <base-button
              icon-right="arrow-right"
              primary
              submit
              :loading="saving">
              Confirm &amp; Save
            </base-button>
          </div>
        </template>
      </form>
    </template>
    <template v-else>
      <base-loader>Loading</base-loader>
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import AppReviews from '@/components/AppReviews.vue'
import AssetCalculator from '@/components/AssetCalculator.vue'
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  async mounted () {
    this.action = this.$route.meta.action

    await this.$store.dispatch('core/asset-statements/get', this.$route.params.id)

    this.payload = this.$_.omit(this.$_.clone(this.assetStatement), ['profile', 'user'])
    this.payload.completed = true
    this.payload.completedAt = this.$moment().format()

    this.loaded = true
  },

  data () {
    return {
      action: 'editing',
      loaded: false,
      payload: {},
      saving: false,
      files: []
    }
  },

  components: {
    AppReviews,
    AssetCalculator,
    HeroHeader
  },

  computed: {
    readonly () {
      return this.action === 'reviewing' || this.action === 'viewing'
    },

    reviewing () {
      return this.action === 'reviewing'
    },

    state () {
      switch (this.action) {
        case 'editing':
          return 'Edit'
        case 'reviewing':
          return 'Review'
        case 'viewing':
          return 'View'
      }
    },

    ...mapState({
      assetStatement: store => store.core.assetStatements.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/asset-statements/save', this.payload)

      this.$flash.success('Asset statement successfully saved.')

      this.$router.push({ name: 'asset-statements' })
    }
  }
}
</script>
